'use client';

import { Printer } from 'lucide-react';
import React from 'react';
import { Button } from '@/components/ui/button';

interface PrintButtonProps extends Omit<React.ComponentProps<typeof Button>, 'onClick' | 'children'> {}

const PrintButton = (props: PrintButtonProps) => {
  return (
    <Button variant="ghost" onClick={() => window.print()} {...props}>
      <Printer size={12} />
    </Button>
  );
};

export default PrintButton;
